import { Method } from './apireftypes';
import { Util } from '../fasades/util';

export class GenCodeJavaScript {
    private method: Method;
    private url: string;
    private body?: object;

    constructor(method: Method, url: string, body?: object) {
        this.method = method;
        this.url = url;
        this.body = body;
    }

    generate(): string {
        const isDelete = this.method === Method.Delete;
        const isStreaming = this.body !== undefined && (this.body as any).stream === true;

        if (this.body !== undefined && !isDelete) {
            if (isStreaming) {
                return this.generateRequest() + '\n\n' + this.readResponseStreaming();
            } else {
                return this.generateRequest() + '\n\n' + this.readResponse();
            }
        } else {
            return this.generateRequest() + '\n\n' + this.readResponse();
        }
    }

    generateRequest(): string {
        const methodString = this.method;
        const isDelete = this.method === Method.Delete;

        if (this.body !== undefined && !isDelete) {
            const jsonString = JSON.stringify(this.body, null, 2);
            // Indent the JSON object to match the code block indentation (add 2 spaces)
            const indentedJson = jsonString.split('\n').map((line, index) => 
                index === 0 ? '    ' + line : '    ' + line
            ).join('\n');

            return `const requestBody = ${indentedJson};

const response = await fetch('${Util.getTigerAPIUrl()}${this.url}', {
  method: '${methodString}',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + process.env.TIGER_API_KEY
  },
  body: JSON.stringify(requestBody)
});

`;
        } else {
            const headers = isDelete 
                ? `  headers: {
    'Authorization': 'Bearer ' + process.env.TIGER_API_KEY
  }`
                : `  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + process.env.TIGER_API_KEY
  }`;

            return `const response = await fetch('${Util.getTigerAPIUrl()}${this.url}', {
  method: '${methodString}',
${headers}
});

`;
        }
    }

    readResponse(): string {
        return `if (!response.ok) {
  throw new Error(\`HTTP error! status: \${response.status}\`);
}

const data = await response.json();
console.log(data);`;
    }

    readResponseStreaming(): string {
        return `if (!response.ok) {
  throw new Error(\`HTTP error! status: \${response.status}\`);
}

const reader = response.body.getReader();
const decoder = new TextDecoder();
let buffer = '';

while (true) {
  const { value, done } = await reader.read();
  if (done) break;
  
  buffer += decoder.decode(value, { stream: true });
  const lines = buffer.split('\\n');
  buffer = lines.pop() || ''; // Keep incomplete line in buffer
  
  for (const line of lines) {
    if (line.trim()) {
      try {
        const chunk = JSON.parse(line);
        
        if (chunk.type === 'info') {
          console.log('Info:', chunk.message);
        } else if (chunk.type === 'delta') {
          process.stdout.write(chunk.delta); // Print incrementally
        } else if (chunk.type === 'stop') {
          console.log('\\nGeneration complete:', chunk.usage);
        } else if (chunk.type === 'error') {
          console.error('Error:', chunk.message);
          break; // Stop processing on error
        }
      } catch (e) {
        console.error('Failed to parse chunk:', line);
      }
    }
  }
}`;
    }

    readResponseStreamingTraining(): string {
        return `if (!response.ok) {
  throw new Error(\`HTTP error! status: \${response.status}\`);
}

const reader = response.body.getReader();
const decoder = new TextDecoder();
let buffer = '';

while (true) {
  const { value, done } = await reader.read();
  if (done) break;
  
  buffer += decoder.decode(value, { stream: true });
  const lines = buffer.split('\\n');
  buffer = lines.pop() || ''; // Keep incomplete line in buffer
  
  for (const line of lines) {
    if (line.trim()) {
      try {
        const chunk = JSON.parse(line);
        
        if (chunk.type === 'info') {
          console.log('Info:', chunk.message);
        } else if (chunk.type === 'performance') {
          const perf = chunk.performance || {};
          console.log(\`Step \${perf.step_no || '?'}, Sample \${perf.id || '?'}: accuracy=\${perf.accuracy || '?'}, advantage=\${perf.advantage || '?'}, loss=\${perf.loss || '?'}\`);
        } else if (chunk.type === 'usage') {
          const usage = chunk.usage || {};
          console.log('Training complete:', usage);
        } else if (chunk.type === 'error') {
          console.error('Error:', chunk.message);
          break; // Stop processing on error
        }
      } catch (e) {
        console.error('Failed to parse chunk:', line);
      }
    }
  }
}`;
    }
}
